import React, { useState } from "react";
import { NavDropdown } from "react-bootstrap";
import { bool, func, object, string } from "prop-types";
import "!style-loader!css-loader!../styles.css";
import CustomDropdownMenu from "./CustomDropdownMenu";

const ManageNavDropdown = ({
  activeNavItem,
  noManageTab,
  handleManageClick,
  getStructuredInterviewItems,
  renderUpgradeOrItem,
  batteriesPermission,
  baselinesPermission,
  analyticsPermission,
  testMakerPermission,
  collaboratorOnlyPermission,
  jobAppsPermission,
  pipelinesPermission,
  landingPagesPermission,
  exitPagesPermission,
  ratingSystemsPermission,
  emailTemplatesPermission,
  isInsightUser,
  showProUpgrades,
  isFreeTrial,
  isTSS,
  userData,
}) => {
  // State to control dropdown open/close
  const [showDropdown, setShowDropdown] = useState(false);

  // State for tooltips
  const [showLandingPagesTooltip, setShowLandingPagesTooltip] = useState(false);
  const [showExitPagesTooltip, setShowExitPagesTooltip] = useState(false);
  const [showEmailTemplatesTooltip, setShowEmailTemplatesTooltip] =
    useState(false);
  const [showRatingSystemsTooltip, setShowRatingSystemsTooltip] =
    useState(false);

  // Tooltip handlers
  const handleLandingPagesTooltipEnter = () => {
    setShowLandingPagesTooltip(true);
  };

  const handleLandingPagesTooltipLeave = () => {
    setShowLandingPagesTooltip(false);
  };

  const handleExitPagesTooltipEnter = () => {
    setShowExitPagesTooltip(true);
  };

  const handleExitPagesTooltipLeave = () => {
    setShowExitPagesTooltip(false);
  };

  const handleEmailTemplatesTooltipEnter = () => {
    setShowEmailTemplatesTooltip(true);
  };

  const handleEmailTemplatesTooltipLeave = () => {
    setShowEmailTemplatesTooltip(false);
  };

  const handleRatingSystemsTooltipEnter = () => {
    setShowRatingSystemsTooltip(true);
  };

  const handleRatingSystemsTooltipLeave = () => {
    setShowRatingSystemsTooltip(false);
  };
  const showAssessmentsManagement =
    !isInsightUser || batteriesPermission || baselinesPermission;
  // Store the interview items to avoid calling the function multiple times
  const interviewItems = getStructuredInterviewItems();
  const showInterviewManagement = !!interviewItems; // Convert to boolean
  const showCandidateExperience =
    jobAppsPermission ||
    emailTemplatesPermission ||
    landingPagesPermission ||
    exitPagesPermission ||
    pipelinesPermission ||
    ratingSystemsPermission;
  const showCandidateManagement =
    pipelinesPermission || ratingSystemsPermission;
  const showReports = analyticsPermission;

  return (
    <NavDropdown
      title="Manage"
      style={{ fontSize: "15px" }}
      className={`${
        activeNavItem === "manage" ? "active" : ""
      } basic-nav-dropdown manage-nav-dropdown`}
      disabled={noManageTab}
      id="nav-manage"
      show={showDropdown}
      onToggle={(isOpen) => setShowDropdown(isOpen)}
    >
      <CustomDropdownMenu
        collaboratorOnlyPermission={collaboratorOnlyPermission}
        isFreeTrial={isFreeTrial}
        isTSS={isTSS}
        showProUpgrades={showProUpgrades}
        userData={userData}
        closeDropdown={() => setShowDropdown(false)}
        show={showDropdown} // Pass dropdown visibility state
      >
        {showAssessmentsManagement && (
          <div className="category-section">
            {!collaboratorOnlyPermission && (
              <NavDropdown.Header
                className="font-weight-bold"
                style={{ color: "#000" }}
              >
                Assessments Management
              </NavDropdown.Header>
            )}
            {batteriesPermission ? (
              <NavDropdown.Item
                eventKey="testbatteries"
                onSelect={handleManageClick}
                id="nav-manage-test-batteries"
              >
                Test Batteries
              </NavDropdown.Item>
            ) : null}
            {baselinesPermission ? (
              <NavDropdown.Item
                eventKey="scoreRanges"
                onSelect={handleManageClick}
                id="nav-manage-score-ranges"
              >
                Score Ranges
              </NavDropdown.Item>
            ) : null}
            {!isInsightUser ? (
              <NavDropdown.Item
                eventKey="assessmentSettings"
                onSelect={handleManageClick}
                id="nav-assessment-settings"
              >
                Assessment Settings
              </NavDropdown.Item>
            ) : null}
            {renderUpgradeOrItem(
              testMakerPermission,
              {
                eventKey: "testmaker",
                onSelect: handleManageClick,
                id: "nav-manage-testmaker-tests",
              },
              "TestMaker Tests"
            )}
          </div>
        )}
        {showInterviewManagement && (
          <div className="category-section">
            <NavDropdown.Header
              className="font-weight-bold"
              style={{ color: "#000" }}
            >
              Interview Management
            </NavDropdown.Header>
            {interviewItems}
          </div>
        )}
        {showCandidateExperience && (
          <div className="category-section">
            <NavDropdown.Header
              className="font-weight-bold"
              style={{ color: "#000" }}
            >
              Candidate Experience
            </NavDropdown.Header>
            {renderUpgradeOrItem(
              jobAppsPermission,
              {
                eventKey: "jobApplications",
                onSelect: handleManageClick,
                id: "nav-manage-job-applications",
              },
              "Job Applications"
            )}
            {renderUpgradeOrItem(
              emailTemplatesPermission,
              {
                eventKey: "emailTemplates",
                onSelect: handleManageClick,
                id: "nav-manage-email-templates",
              },
              "Email Templates",
              "emailTemplates",
              true,
              {
                show: showEmailTemplatesTooltip,
                onMouseEnter: handleEmailTemplatesTooltipEnter,
                onMouseLeave: handleEmailTemplatesTooltipLeave,
                isFreeTrial,
                userData,
              }
            )}
            {renderUpgradeOrItem(
              landingPagesPermission,
              {
                eventKey: "landingPages",
                onSelect: handleManageClick,
                id: "nav-manage-landing-pages",
              },
              "Landing Pages",
              "landingPages",
              true,
              {
                show: showLandingPagesTooltip,
                onMouseEnter: handleLandingPagesTooltipEnter,
                onMouseLeave: handleLandingPagesTooltipLeave,
                isFreeTrial,
                userData,
              }
            )}
            {renderUpgradeOrItem(
              exitPagesPermission,
              {
                eventKey: "exitPages",
                onSelect: handleManageClick,
                id: "nav-manage-exit-pages",
              },
              "Exit Pages",
              "exitPages",
              true,
              {
                show: showExitPagesTooltip,
                onMouseEnter: handleExitPagesTooltipEnter,
                onMouseLeave: handleExitPagesTooltipLeave,
                isFreeTrial,
                userData,
              }
            )}
          </div>
        )}
        {showCandidateManagement && (
          <div className="category-section">
            <NavDropdown.Header
              className="font-weight-bold"
              style={{ color: "#000" }}
            >
              Candidate Management
            </NavDropdown.Header>
            {renderUpgradeOrItem(
              pipelinesPermission,
              {
                eventKey: "pipelines",
                onSelect: handleManageClick,
                id: "nav-manage-pipelines",
              },
              "Pipelines"
            )}
            {renderUpgradeOrItem(
              ratingSystemsPermission,
              {
                eventKey: "ratings",
                onSelect: handleManageClick,
                id: "nav-manage-rating-systems",
              },
              "Rating Systems",
              "ratingSystems",
              true,
              {
                show: showRatingSystemsTooltip,
                onMouseEnter: handleRatingSystemsTooltipEnter,
                onMouseLeave: handleRatingSystemsTooltipLeave,
                isFreeTrial,
                userData,
              }
            )}
          </div>
        )}
        {showReports && (
          <div className="category-section">
            <NavDropdown.Header
              className="font-weight-bold"
              style={{ color: "#000" }}
            >
              Reports
            </NavDropdown.Header>
            {analyticsPermission ? (
              <NavDropdown.Item
                eventKey="reports"
                onSelect={handleManageClick}
                id="nav-manage-test-reports"
              >
                Run Reports
              </NavDropdown.Item>
            ) : null}
          </div>
        )}
      </CustomDropdownMenu>
    </NavDropdown>
  );
};

ManageNavDropdown.propTypes = {
  activeNavItem: string,
  noManageTab: bool,
  handleManageClick: func,
  getStructuredInterviewItems: func,
  renderUpgradeOrItem: func,
  batteriesPermission: bool,
  baselinesPermission: bool,
  analyticsPermission: bool,
  testMakerPermission: bool,
  collaboratorOnlyPermission: bool,
  jobAppsPermission: bool,
  pipelinesPermission: bool,
  landingPagesPermission: bool,
  exitPagesPermission: bool,
  ratingSystemsPermission: bool,
  emailTemplatesPermission: bool,
  isInsightUser: bool,
  showProUpgrades: bool,
  isFreeTrial: bool,
  isTSS: bool,
  userData: object,
};

export default ManageNavDropdown;
